import Debug from "../../images/Icons/gg_debug.png";
import Quiz from "../../images/Icons/quiz.png";
import Ctf from "../../images/Icons/ctf.png";
import Data from "../../images/Icons/data.png";
import Code from "../../images/Icons/code.png";
import Game from "../../images/Icons/game.png";
import Project from "../../images/Icons/project.png";
import Ui from "../../images/Icons/ui.png";
import Sql from "../../images/Icons/sql.png";
import Bot from "../../images/Icons/bot.png";
import Dev from "../../images/Icons/dev.png";
const EventData = [
  {
    id: 1,
    img: Quiz,
    title: "Technical Quiz",
    description:
      "The Technical quiz event is all about technical questions from subjects like DBMS, Computer Fundamentals, Data Structures, Networks, Computer Architecture, OS, Internet Technologies and Current Affairs in IT. It is a tech clash of brain over brawn of the best minds slaying the opponents figuring out through 3 rounds.",
    rounds: 3,
    limit: "Individual Event",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSeSEvD2Sw145_zmvzo6xe4FhKdtm-nneliFcWY7wtwSU5u4jw/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "This round consists of MCQ’s and will be conducted through hackerrank platform",
      },
      {
        round: 2,
        round_description:
          "Shortlisted students will participate in a quiz round",
      },
      {
        round: 3,
        round_description:
          "Final round with a combination of second and third year students 2 per team is made to fight to pick the best.",
      },
    ],
    iconClass: "ri-flashlight-line",
    hue1: 210,
    hue2: 238,
  },
  {
    id: 2,
    title: "Debugging",
    img: Debug,
    description:
      "In this competition, participants will face online challenges designed to test their debugging skills. Each challenge will come with specified test case examples to guide their approach. The focus will be on evaluating how efficiently and effectively participants can identify and resolve bugs within C code, ensuring accuracy and optimization.",
    rounds: 2,
    limit: "Individual Event",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSc7yGlZWUqEK_2jf3OWIrmf37P1OAvXHzf4C3k8cuCmi79DqQ/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will be presented with basic debugging questions, and selection will be based on the number of questions successfully solved and the time taken to complete them.",
      },
      {
        round: 2,
        round_description:
          "Participants will tackle complex debugging questions that involve data structures and programming logic. Selection will be determined by the maximum number of questions solved and the shortest time taken to complete them.",
      },
    ],
    iconClass: "ri-fire-line",
    hue1: 300,
    hue2: 30,
  },
  {
    id: 3,
    title: "Code Relay",
    img: Code,
    description:
      "As a core event for CSE students, this competition challenges participants to solve coding problems efficiently in their choice of language: C, C++, Python, or Java. The event emphasizes coding proficiency and problem-solving skills.",
    rounds: 2,
    limit: "Team Size 4",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdI_AwTuwgPBRMtsxOMvaYT1mcsVNQvFNfXjhG08nEZaOpAbQ/viewform?usp=sharing  ",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will face coding challenges designed to test their problem-solving abilities. The individuals who solve the most problems will be shortlisted for the next round.",
      },
      {
        round: 2,
        round_description:
          "In this round, teams will consist of 4 members (2 second-year and 2 third-year students). The team will be given 4 coding problems to solve within a 2-hour timeframe. Each team member will have 30 minutes to tackle their assigned problem. If a member is unable to solve their problem within the allotted time, the next team member will move on to the next problem. However, if a member finishes early, the remaining time will roll over, giving the next member additional time to solve their problem.",
      },
    ],
    iconClass: "ri-shining-line",
    hue1: 180,
    hue2: 50,
  },
  {
    id: 4,
    title: "Project Presentation",
    img: Project,
    description:
      "Project Presentation event is organized to serve as a platform for all the budding software engineers to showcase their marvelous ideas as projects.",
    rounds: 3,
    limit: "Team Size 2-3",
    eligibility: "Only 2nd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSfsB01qfq8si8_vOvJNg3_FaSkV34_1uy4N9MufmC4SQwZ2Yw/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants are shortlisted based on their abstract and presentation provided",
      },
      {
        round: 2,
        round_description:
          " The organizers and faculty will shortlist the students based on their performance in the given period of time.",
      },
      {
        round: 3,
        round_description:
          "The final project is presented in front of a panel of judges and the winner is decided. Students will be requested to maintain a git repository during the whole project.",
      },
    ],
    iconClass: "ri-flashlight-line",
    hue1: 210,
    hue2: 238,
  },
  {
    id: 5,
    title: "Capture The Flag",
    img: Ctf,
    description:
      "Capture the flag is a computer security competition. Participants compete in security themed challenges for the purpose of obtaining the highest score. Competitors are expected to capture the flags to increase their score, hence the name of the event. Flags are generally random strings in a given format.",
    rounds: 2,
    limit: "Individual Event",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLScVzq88F86Nza0lxrG_4z_gTU0iLozwhGVjmyF5pUX9xTOXVw/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "This round consists of MCQ’s and will be conducted through hackerrank platform.",
      },
      {
        round: 2,
        round_description:
          " Participants will be given a day to find flags. The participant who finds the maximum number of flags wins the competition",
      },
    ],
    iconClass: "ri-fire-line",
    hue1: 300,
    hue2: 30,
  },
  {
    id: 6,
    title: "Product Development",
    img: Dev,
    description:
      "The Product Development Event, a mini hackathon, challenges participants to build a mobile or web app within a set timeframe. This coding event brings together programmers to collaborate on enhancing or creating a new application. The problem statement is provided on the spot, and participants must develop a solution during the event.",
    rounds: 2,
    limit: "Team Size 2-3",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdms8dW7ILzfoPVt1fTarw-4pOfhIEiM-IZKsapnO7OtwseVQ/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants are shortlisted based on their understanding of fundamentals and proficiency in product design, including their skills with Git.",
      },
      {
        round: 2,
        round_description:
          "Teams will receive a problem statement and have certain time to work on it, with an open choice of tech stack. Judging will occur in three rounds, evaluating various factors.",
      },
    ],
    iconClass: "ri-shining-line",
    hue1: 180,
    hue2: 50,
  },
  {
    id: 7,
    title: "Bot-A-Mata",
    img: Bot,
    description:
      "Robotic process automation (RPA) is a productivity tool that allows a user to configure one or more scripts (bots) to activate specific keystrokes in an automated manner.",
    rounds: 2,
    limit: "Individual Event",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSfuNG2KRzj95zlPAfkXGIdReyV4iVq8XKtuEtkq0w8o1ddWnQ/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "	Students are shortlisted based on a basic web or desktop automation using RPA.",
      },
      {
        round: 2,
        round_description: "An advanced level of RPA automation.",
      },
    ],
    iconClass: "ri-flashlight-line",
    hue1: 210,
    hue2: 238,
  },
  {
    id: 8,
    title: "Game Jam",
    img: Game,
    description:
      "Game Development is an event that brings creative programmers together and engages them in collaborative game programming by improving upon or building a new game. The problem statement in the form of a story would be given to the teams and the one to implement creative and most features will be declared the winners. ",
    rounds: 2,
    limit: "Team Size 2-3",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSc6rCa6zOKKpYHMzoyeXSmD-1S5OIeINWL_HIN8PSjJ_8s8dQ/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will answer multiple-choice questions covering fundamental concepts of game development and topics discussed during the workshop. The top scorers will advance to the next round.",
      },
      {
        round: 2,
        round_description:
          "Teams will be provided with a story prompt and will have the day to develop their project. Judging will occur in three stages, evaluating various aspects of their work.",
      },
    ],
    iconClass: "ri-fire-line",
    hue1: 300,
    hue2: 30,
  },
  {
    id: 9,
    title: "SQL Detective",
    img: Sql,
    description:
      "This event challenges participants to apply both their logical reasoning and SQL skills. Participants will be presented with a mystery scenario, and they must explore the database to answer related questions. The individual who answers the most questions in the shortest time will be declared the winner.",
    rounds: 3,
    limit: "Team Size 2-3",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSc1j0CmewKzR5IregU1JbbNbFj0ij8tKL249LshKMNPMYjJUQ/viewform?usp=sharing",
    eligibility: "Both 2nd and 3rd Years",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will face multiple-choice questions covering fundamental SQL queries and topics discussed during the workshop. Top performers will advance to the next round.",
      },
      {
        round: 2,
        round_description:
          " Participants will demonstrate their query skills by solving a series of SQL problems. Those who solve the most problems will proceed to the final round.",
      },
      {
        round: 3,
        round_description:
          "Teams will be given a mystery scenario and must answer related questions by exploring the database. The team that answers the most questions in the shortest time will be declared the winner.",
      },
    ],
    iconClass: "ri-shining-line",
    hue1: 180,
    hue2: 50,
  },
  {
    id: 10,
    title: "UI/UX Designing",
    img: Ui,
    description:
      "UI/UX designers create the user interface for an app, website, or other interactive media. The idea is to create a user-friendly interface that enables the user to understand how to use complex technical products.",
    rounds: 2,
    limit: "Individual Event",
    eligibility: "Both 2nd and 3rd Years",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSd94f8Y_1F3O09AMTAOG07sIWrJ0RjrotLDYaAeLzpYdkElWg/viewform?usp=sharing",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Create a low-fidelity wireframe or prototype for a given application or website. Online submission of wireframes or prototypes.",
      },
      {
        round: 2,
        round_description:
          "Build a complete high-fidelity user interface for an application based on a provided brief submission of interactive high-fidelity screens. Judging Criteria: Visual design, usability, adherence to the brief, overall presentation.",
      },
    ],
    iconClass: "ri-flashlight-line",
    hue1: 210,
    hue2: 238,
  },
  {
    id: 11,
    title: "Data Dash",
    img: Data,
    description:
      " This data science event challenges participants to analyze a real-time dataset and extract meaningful insights. Participants will submit a detailed notebook showcasing their analysis.",
    rounds: 2,
    limit: "Team Size 2-3",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSeLhgDUfBB1854V0wTggEoqbO9dWWnJ7UGPJC92z3jk61AoNg/viewform?usp=sharing",
    eligibility: "Both 2nd and 3rd Years",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will complete a multiple-choice quiz focused on basic data analytics concepts. Top performers will advance to the final round.",
      },
      {
        round: 2,
        round_description:
          "Participants will be provided with a dataset and a problem statement. They must analyze the dataset and uncover insights using Power BI. Points will be awarded based on the number and quality of insights derived.",
      },
    ],
    iconClass: "ri-fire-line",
    hue1: 300,
    hue2: 30,
  },
  {
    id: 12,
    title: "Workshops",
    img: Data,
    rounds: 0,
    description:
      "The Techathon event will include workshops on Data Dash, Webflow, UI/UX, SQL, and Interview Preparation, alongside exciting activities like Game Jam, Bot-A-Mata, and Capture the Flag. These sessions and events offer a mix of learning opportunities and competitive fun in various tech fields.",
    limit: "Team Size 2-3",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSeMv19qxiBMB6MGuy0ZXxWLKsZM6tsBFrLDdmUdfNwOcjxJgg/viewform",
    eligibility: "Both 2nd and 3rd Years",
    round_descriptions: [
      {
        round: 1,
        round_description:
          "Participants will complete a multiple-choice quiz focused on basic data analytics concepts. Top performers will advance to the final round.",
      },
      {
        round: 2,
        round_description:
          "Participants will be provided with a dataset and a problem statement. They must analyze the dataset and uncover insights using Power BI. Points will be awarded based on the number and quality of insights derived.",
      },
    ],
    iconClass: "ri-shining-line",
    hue1: 180,
    hue2: 50,
  },
];

export default EventData;
